import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../constants';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = () => (windowSize.width < MOBILE_BREAKPOINT);

  return { windowSize, isMobile };
};

export default useWindowSize;
